// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"header_heroImage__d0sEU"};